import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon, FacebookIcon, MenuIcon, SearchIcon, UserIcon, XIcon } from 'lucide-react';
import { LOGO_URL, navigation } from '../data/site';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const {
    pathname
  } = useLocation();
  return <header className="sticky top-0 z-40 w-full" data-id="element-40" data-mp="2rl485s1i0jyc">
      <div className="hidden bg-nuit text-creme md:block" data-id="element-41" data-mp="2rkb634dhiimj">
        <div className="mx-auto flex max-w-7xl items-center justify-end gap-6 px-6 py-2 text-[13px]" data-id="element-42" data-mp="2wjxjpex860vv">
          <a href="https://www.facebook.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-soleil" data-id="element-43" data-mp="31cgz8hfh363b">
            <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="3bb651bu3h037" />
            <span className="sr-only sm:not-sr-only" data-id="element-45" data-mp="3fbgn3mv5vgyf">Facebook</span>
          </a>
          <Link to="/liens-utiles" className="transition-colors duration-150 ease-out hover:text-soleil" data-id="element-46" data-mp="3f9dm67sh03ex">
            Liens utiles
          </Link>
          <Link to="/espace-adherent" className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 transition-colors duration-150 ease-out hover:bg-soleil hover:text-nuit" data-id="element-47" data-mp="2rkgh3jopsnby">
            <UserIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="3fbcceqsdq0ny" />
            Connexion espace adhérent
          </Link>
          <button type="button" className="transition-colors duration-150 ease-out hover:text-soleil" aria-label="Rechercher sur le site" data-id="element-49" data-mp="3abpptqqnv82h">
            <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="30mpnpygv3wk2" />
          </button>
        </div>
      </div>

      <div className="border-b border-nuit/10 bg-creme/95 backdrop-blur" data-id="element-51" data-mp="1wz9ybjgfdej">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-3" data-id="element-52" data-mp="1yafogwgmv8a">
          <Link to="/" className="flex items-center gap-3" aria-label="Les Magiciens de la Nuit — accueil" data-id="element-53" data-mp="3t9afh0192ao5">
            <img src={LOGO_URL} alt="Les Magiciens de la Nuit" className="h-12 w-auto md:h-14" data-id="element-54" data-mp="1wco7zzb85k6f" />
            <span className="hidden text-[11px] font-semibold uppercase tracking-[0.18em] text-nuit/60 lg:block" data-id="element-55" data-mp="1hnrqzcr6wwto">
              Spectacles
              <br data-id="element-56" data-mp="1mlt8vucvqq3k" />
              son et lumière
            </span>
          </Link>

          <nav aria-label="Navigation principale" className="hidden items-center gap-1 lg:flex" data-id="element-57" data-mp="18mk4rt1y7mfy">
            {navigation.map(item => {
            const active = pathname === item.href;
            return <div key={item.label} className="relative" onMouseEnter={() => setOpenMenu(item.label)} onMouseLeave={() => setOpenMenu(null)} data-id="element-58" data-mp="ypxkb5djaxeg">
                  <Link to={item.href} className={`flex items-center gap-1 rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-150 ease-out ${active ? 'bg-nuit text-creme' : 'text-nuit hover:bg-nuit/5'}`} data-id="element-59" data-mp="2t3q8m50for6i">
                    {item.label}
                    {item.children && <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-60" data-mp="w60xdvrzm3rg" />}
                  </Link>
                  {item.children && openMenu === item.label && <div className="absolute left-0 top-full w-64 pt-2" data-id="element-61" data-mp="154cy4qmkihxm">
                      <ul className="overflow-hidden rounded-2xl border border-nuit/10 bg-white py-2 shadow-soft" data-id="element-62" data-mp="106310aha979d">
                        {item.children.map(child => <li key={child.href} data-id="element-63" data-mp="1f197szo7da3r">
                            <Link to={child.href} className="block px-4 py-2 text-sm text-nuit/80 transition-colors duration-150 ease-out hover:bg-grege hover:text-nuit" data-id="element-64" data-mp="1a3z9svmqzq4b">
                              {child.label}
                            </Link>
                          </li>)}
                      </ul>
                    </div>}
                </div>;
          })}
          </nav>

          <div className="hidden lg:block" data-id="element-65" data-mp="2cxcw8uv2tfl1">
            <Link to="/a-propos/contact" className="rounded-full bg-braise px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-passion" data-id="element-66" data-mp="2gygd9kov1hnu">
              Nous rejoindre
            </Link>
          </div>

          <button type="button" onClick={() => setMobileOpen(v => !v)} className="rounded-full border border-nuit/15 p-2 text-nuit lg:hidden" aria-expanded={mobileOpen} aria-label={mobileOpen ? 'Fermer le menu' : 'Ouvrir le menu'} data-id="element-67" data-mp="1p4wb2bg1l7hi">
            {mobileOpen ? <XIcon className="h-5 w-5" data-id="element-68" data-mp="15j1goi0kcrt9" /> : <MenuIcon className="h-5 w-5" data-id="element-69" data-mp="15i8615yhhi5u" />}
          </button>
        </div>

        {mobileOpen && <nav aria-label="Navigation mobile" className="border-t border-nuit/10 bg-creme lg:hidden" data-id="element-70" data-mp="xyh2clmvlfbi">
            <ul className="mx-auto max-w-7xl px-6 py-3" data-id="element-71" data-mp="t1yzjrb3vr1t">
              {navigation.map(item => <li key={item.label} className="border-b border-nuit/5 last:border-0" data-id="element-72" data-mp="oxrcdykaqj5p">
                  <Link to={item.href} onClick={() => setMobileOpen(false)} className="block py-3 font-semibold text-nuit" data-id="element-73" data-mp="jyxwy0lg8i2w">
                    {item.label}
                  </Link>
                  {item.children && <ul className="pb-3 pl-4" data-id="element-74" data-mp="5bwazl6eh37y">
                      {item.children.map(child => <li key={child.href} data-id="element-75" data-mp="1astku8pez4m">
                          <Link to={child.href} onClick={() => setMobileOpen(false)} className="block py-1.5 text-sm text-nuit/70" data-id="element-76" data-mp="3sfsxvaiorsec">
                            {child.label}
                          </Link>
                        </li>)}
                    </ul>}
                </li>)}
              <li className="pt-4" data-id="element-77" data-mp="33w7p30qpop2c">
                <Link to="/a-propos/contact" onClick={() => setMobileOpen(false)} className="block rounded-full bg-braise px-5 py-3 text-center font-semibold text-white" data-id="element-78" data-mp="33xafl7k4gphq">
                  Nous rejoindre
                </Link>
              </li>
            </ul>
          </nav>}
      </div>
    </header>;
}